import { generateUniqueId } from '@acre/utils'
import { CreateGeneralInsuranceProductDetails, GeneralInsuranceQuoteStage } from '@acre/graphql'

import { getProviderName } from '../../../../pages/GeneralInsurance/GeneralInsuranceQuoting/GeneralInsuranceQuotingItem/GeneralInsuranceQuotingItem.helpers'

export const getPredictedRevenueFromGI = (giProducts: CreateGeneralInsuranceProductDetails[]) => {
  const selectedGIProducts = giProducts.filter(
    (product) =>
      product.commission &&
      (product.status === GeneralInsuranceQuoteStage.Selected ||
        product.status === GeneralInsuranceQuoteStage.ApplicationInProgress),
  )

  return selectedGIProducts.map((product) => {
    const providerName = getProviderName(product?.provider || '')

    return {
      id: generateUniqueId(),
      value: product.commission,
      fee_type: 'giProcFee',
      payer: providerName !== 'Unknown provider' ? providerName : 'insurer',
      commission: null,
      frequency: null,
      commission_period: null,
    }
  })
}
